import React from 'react';
import {Box, createTheme, ThemeProvider, Toolbar} from "@mui/material";
import TopBar from "./components/TopBar";

interface Props {
    children: React.ReactNode
}


const theme = createTheme({
    typography: {
        // Tell Material UI what the font-size on the html element is.
        // htmlFontSize: 18,
        body1: {
            fontSize: '1.1rem',
        },
    },
});


const Layout = ( { children }: Props) => {
    return (
        <ThemeProvider theme={theme}>
            <TopBar />
            {/*//  extra toolbar space */}
            <Toolbar />
            <Box sx={{flexGrow: 1}}>
                {children}
            </Box>
        </ThemeProvider>
    )
}
export default Layout;
